import React, { useState } from "react";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";

const FilterDropdown = ({optionData, onSelect}) => {
  const [options, setOptions] = useState(false);

  const onClickAction = (id, value) => {
    onSelect(id, value)
    setOptions(false)
  }

  return (
    <Dropdown isOpen={options} toggle={() => setOptions(!options)}>
      <DropdownToggle className="filter-add-btn ms-2 my-1" tag="button">
        <i className="bx bx-plus ms-1 font-size-16"></i>
        Шүүлтүүрийн утга
      </DropdownToggle>
      <DropdownMenu className="dropdown-menu pt-3">
        {
          Object.entries(optionData).map(([key, value]) => (
            <DropdownItem 
              tag="div"
              key={`filter-dropdown-${key}`}
              className="pointer px-4 py-2" 
              onClick={() => onClickAction(key, value)}>
              {value}
            </DropdownItem>
          ))
        }
      </DropdownMenu>
    </Dropdown>
  );
};

export default FilterDropdown;
